import React from 'react'

export default function Footer() {
    return (
        <div className="footer-section">
            <div className="container">
                <div className="footer-logo-copyright">
                    <div className="copyright ps-0 text-center">
                        <p>© 2024 ClearView. All rights reserved.</p>
                    </div>
                </div>

            </div>
        </div>

    )
}
